<div>
  <div *ngFor="let type of innerTypes" [hidden]="!isHidden">
    <h4>{{ type }}</h4>
    <div *ngFor="let template of smsTemplates[messageInnerTypes[type]]">
      <button
        type="button"
        class="btn btn-primary btn-custom"
        (click)="onClick(template?.messageName, template?.messageContent)"
      >
        {{ template.messageName }}
      </button>
    </div>
  </div>

  <div [hidden]="isHidden">
    <button type="button" class="btn btn-default" (click)="onBack()">
      {{ 'label.NavigationBack' | translate }}
    </button>
    <br />
    <hr-template-display
      [templateTitle]="smsTemplateTitle"
      [templateContent]="smsTemplate"
    >
    </hr-template-display>
  </div>
</div>
